import { creditConstants } from '../constants'
import {
    getOptionscmb, getFormatData, getFormatCalculateData
} from '../../utils'

export const CreditOption = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.CREDITOPTION_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.CREDITOPTION_SUCCESS:
            return { loading: false, items: action.creditData.Body, error: undefined }
            
        case creditConstants.CREDITOPTION_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const AsignateCreditOption = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.ASIGNATE_CREDITOPTION_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.ASIGNATE_CREDITOPTION_SUCCESS:
            return { loading: false, items: action.asignatedCreditData.Body, error: undefined }
            
        case creditConstants.ASIGNATE_CREDITOPTION_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const CobranzaPagos = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.COBRANZA_PAGOS_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.COBRANZA_PAGOS_SUCCESS:
            return { loading: false, items: action.cobranzaCredData.Body, error: undefined }
            
        case creditConstants.COBRANZA_PAGOS_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const GeneraCobranzaUnico = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.GENERAR_DATOS_COBRNZA_UNICO_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.GENERAR_DATOS_COBRNZA_UNICO_SUCCESS:
            return { loading: false, items: action.generaCzaCredData.Body, error: undefined }
            
        case creditConstants.GENERAR_DATOS_COBRNZA_UNICO_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const CobranzaCobro = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.COBRANZA_COBRO_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.COBRANZA_COBRO_SUCCESS:
            return { loading: false, items: action.cobranzaCobro.Body, error: undefined }
            
        case creditConstants.COBRANZA_COBRO_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const UserGoalData = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.GETUSERS_GOAL_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.GETUSERS_GOAL_SUCCESS:
            return { loading: false, items: action.userData.Body, error: undefined }
            
        case creditConstants.GETUSERS_GOAL_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const RegisterUserGoalData = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.REGISTER_USER_GOAL_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.REGISTER_USER_GOAL_SUCCESS:
            return { loading: false, items: action.regUserData.Body, error: undefined }
            
        case creditConstants.REGISTER_USER_GOAL_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const DependenciesData = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.GETDEPENDENCIES_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.GETDEPENDENCIES_SUCCESS:
            return {
                loading: false,
                items: action.dependData.Body,
                options: getOptionscmb(action.dependData.Body),
                formatData: getFormatData(action.dependData.Body),
                error: undefined
            }
            
        case creditConstants.GETDEPENDENCIES_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const CalculateDataFile = (state = {}, action) => {
    switch (action.type) {
        case creditConstants.GETCALCULATE_DATAFILE_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case creditConstants.GETCALCULATE_DATAFILE_SUCCESS:
            return {
                loading: false,
                items: action.calculaData.Body,
                itemsFormat: getFormatCalculateData(action.calculaData.Body),
                error: undefined
            }
            
        case creditConstants.GETCALCULATE_DATAFILE_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}